import axios from 'axios';

export const LoggedUserApi = {
    getLoggedUser: () => axios.get('/web/logged-user/'),
    changePassword: (currentPassword, newPassword) => axios.put('/web/logged-user/password/', { currentPassword, newPassword }),
    update: (loggedUserData) => axios.put('/web/logged-user/', loggedUserData),
    changeCompanyGroupCompany: (companyGroup, companyId) => axios.put('/web/logged-user/company/', { companyGroup, companyId })
};
